import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';
export default class CommandTriggeredNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Command';
        this.id = 'node_command_triggered';
        this.icon = 'HiCommandLine';
        this.linkedFeature = 'commands';

        this.outputs = [
            {
                name: 'Pressed',
                portId: 'on_command_triggered',
                params: [
                    {
                        name: 'data',
                        dataType: TibboDataType.STRING,
                    },
                ],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'COMMAND',
                name: 'Command',
                settingType: SettingType.OPTION,
                refId: 'command',
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const project: ProjectConfiguration = this.project;
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const COMMAND = project.getFeature(this.getSettingValue('COMMAND'));
            if (COMMAND) {
                return `{{$${COMMAND.getSettingValue('NAME')}}} triggered`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const COMMAND = project.getFeature(this.getSettingValue('COMMAND'));
        if (COMMAND) {
            return `{{$${COMMAND.getSettingValue('NAME')}}} triggered`;
        }
        return this.name;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return 'This block is triggered when the device receives a command from the dashboard or cloud.';
    }
}
